export default "__VITE_ASSET__oK9Y0aog__"